import { ELVESZETT_OK_CIMKE, TIPUS_CIMKE } from '../lib/tipusok.ts';

const FORRAS: Record<string, string> = { google: 'Google keresés', facebook: 'Facebook', instagram: 'Instagram' };

export function forrasCimke(forras: string | null): string {
  if (forras === null) return 'Közvetlen';
  return FORRAS[forras] ?? forras.charAt(0).toUpperCase() + forras.slice(1);
}

export function kampanyCimke(kampany: string | null): string {
  return kampany ?? 'nincs kampányadat';
}

export function elvesztOkCimke(ok: string): string {
  return ELVESZETT_OK_CIMKE[ok] ?? ok;
}

const TOLCSER: Record<string, string> = {
  megerositett: 'Megerősített lead',
  elerve: 'Elérve',
  szemle_egyeztetve: 'Szemle egyeztetve',
  szemle_megtortent: 'Szemle megvolt',
  megbizas: 'Megbízás',
  eladva: 'Eladva',
};
export function tolcserCimke(lepes: string): string {
  return TOLCSER[lepes] ?? lepes;
}

export function tipusCimke(tipus: string): string {
  return (TIPUS_CIMKE as Record<string, string>)[tipus] ?? tipus;
}

// Az árelvárás a tulajdonos szemszögéből: `alatta` = az eredmény alacsonyabb a vártnál.
const ARELVARAS: Record<string, string> = { alatta: 'Többre számított', benne: 'Ennyire számított', folotte: 'Kevesebbre számított' };
export function arelvarasCimke(ertek: string): string {
  return ARELVARAS[ertek] ?? ertek;
}

const IDOSAV: Record<string, string> = { delelott: 'Délelőtt', delutan: 'Délután', este: 'Este', barmikor: 'Bármikor' };
export function idosavCimke(ertek: string): string {
  return IDOSAV[ertek] ?? ertek;
}
